module.exports = __webpack_public_path__ + "static/media/creditcard.5710702b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/creditcard.svg
 ** module id = 123
 ** module chunks = 0
 **/